// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricC":"C_SaveElectricC__q4VM8"};